import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { saveChanges } from 'bundles/apex/pipeline/settings/store/actions';

import Button from 'shared/button';
import Errors from 'components/form/errors';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import ManagedInput from 'components/form/managed_input';
import Modal from 'components/modal';
import StageLabel from './stage_label';

export function EditStageModal({
  defaultLabel,
  errors,
  saveChanges,
  saving,
  show,
  stage,
  onHide,
}) {
  const [label, setLabel] = useState('');
  const [defaultCloseProbability, setDefaultCloseProbability] = useState(0);
  const [backfillCheck, setBackfillCheck] = useState(false);

  function reset() {
    const stageLabel = stage?.label === defaultLabel ? '' : stage?.label;
    setLabel(stageLabel);
    setDefaultCloseProbability(stage?.defaultCloseProbability);
    setBackfillCheck(false);
  }

  function handleSave() {
    saveChanges({
      ...stage,
      label: label || defaultLabel,
      defaultCloseProbability: defaultCloseProbability,
      backfillCheck,
    });
  }

  return (
    <Modal show={show} onHide={onHide} onShow={reset}>
      <Modal.Header closeButton>Edit Pipeline Stage</Modal.Header>

      <Modal.Body className="d-flex flex-column gap-2">
        <Errors description={false} errors={errors} />

        <StageLabel stage={stage} />

        <ManagedFormGroup
          label="Custom Label"
          name="customLabel"
          placeholder={defaultLabel}
          value={label}
          onValueChange={setLabel}
        />

        <ManagedFormGroup
          label="Default Close Probability"
          name="defaultCloseProbability"
          type="percentage"
          value={defaultCloseProbability === 0 ? '0' : defaultCloseProbability}
          onValueChange={setDefaultCloseProbability}
        />

        {(defaultCloseProbability || defaultCloseProbability === 0) &&
          <ManagedInput
            name="backfillCheck"
            type="checkbox"
            value={backfillCheck}
            wrapperClassName="mt-3"
            onValueChange={setBackfillCheck}
          >
            Update close probability for all existing {label || defaultLabel} deals
          </ManagedInput>
        }
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel onClick={onHide} />
        <Button.Primary disabled={saving} onClick={handleSave}>Save</Button.Primary>
      </Modal.Footer>
    </Modal>
  );
}

EditStageModal.propTypes = {
  defaultLabel: PropTypes.string.isRequired,
  errors: PropTypes.array,
  saveChanges: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  show: PropTypes.bool.isRequired,
  stage: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    defaultCloseProbability: PropTypes.number,
  }),
  onHide: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  saving: state.saving,
  errors: state.errors,
});

const mapDispatchToProps = {
  saveChanges,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditStageModal);
